import { OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, publishReplay, refCount } from 'rxjs/operators';
import { Category, Report } from '../../documents';
import { GeneralReportsStorage } from '../general-reports-storage';

export abstract class GeneralDocumentsComponentBase implements OnInit {
    public reports: Observable<Report[]>;
    public selectedCategory: Observable<Category>;

    constructor(protected reportsStorage: GeneralReportsStorage) { }

    public ngOnInit() {
        this.selectedCategory = this.createSelectedCategory();

        this.reports = this.reportsStorage
            .loadReports(
                this.selectedCategory
                    .pipe(
                        filter(x => !!x),
                        publishReplay(1),
                        refCount()
                    ));
    }

    protected abstract createSelectedCategory(): Observable<Category>;
}